<template>
<div class="wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <router-link class="btn btn-primary" :to="{ name: 'CustomerPlacesList', params: { searchval: $props.searchval }}">Tillbaka till filtrerad vy</router-link>
      </div>
    </div>
  </div>
  <div class="container details">
    <div class="row">
      <div class="col-md-12">
        <h1 v-if="customerPlace && customerPlace.data">{{customerPlace.data.name}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
      <form>
        <vue-form-generator :schema="schema" :model="customerPlace.data" />
      </form>
      </div>
    </div>
    <div class="row" v-if="schema.objectProps && schema.objectProps.hasComments">
      <div class="col-md-12">
         <CommentList :objectId="customerPlace.customerPlaceId" />
      </div>
    </div>
    <div class="row" v-if="schema.objectProps && schema.objectProps.hasComments">
      <div class="col-md-12">
        <CommentCreate :objectId="customerPlace.customerPlaceId" />
      </div>
    </div>
    <div style="margin-bottom: 120px;" class="row" v-if="schema.objectProps && schema.objectProps.hasLocation">
      <div class="col-md-12">
        <Map
            :dataArray = "mapArray"
            width="100%"
            zoom = "false"
            height="500px"
            :getGeoCoder="true"
            :customerPlace="customerPlace"
            :draggable="true" />
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button  label="Spara" class="p-button-success" @click="onSave()" icon="pi pi-check" ></Button>
        <Button  label="Ta bort" class="p-button-danger" @click="onDelete()" icon="pi pi-times" ></Button>
        <Button  label="Kopiera" class="p-button-success" @click="onCopy()" icon="pi pi-file" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Map from '@/components//Map/Map'
import CommentList from '../Comments/CommentList'
import CommentCreate from '../Comments/CommentCreate'
import Button from 'primevue/button'
import { bus } from '../../main'
export default {
  name: 'CustomerPlacesDetails',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Map,
    CommentList,
    CommentCreate,
    Button
  },
  data () {
    return {
      customerPlace: {},
      schema: {},
      customerName: '',
      mapArray: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    searchval: {
      type: String
    }
  },
  watch: {
    customerPlace: function (newVal, oldVal) {
      this.customerPlace = newVal
    },
    id: function (newVal, oldVal) {
      this.getCustomerPlace(newVal)
    }
  },
  async mounted () {
    await this.getCustomerPlace(this.$route.params.id)
    bus.$on('updateCustomerPlace', (customerPlace) => {
      this.customerPlace = customerPlace
    })
  },
  methods: {
    async getCustomers () {
      var customerSelect = this.schema.fields.find(field => field.model === 'kund')
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          for (var i = 0; i < customers.length; i++) {
            customerSelect.values.push({'id': customers[i].id, 'name': customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    async getCustomerPlace (id) {
      var url = '/api/customersplaces/' + id
      this.$http
        .get(url)
        .then(response => {
          this.customerPlace = response.data.customersplace
          this.customerPlace.data['kund'] = response.data.customersplace.Customer.data.name
          this.schema = response.data.schema
          var customer = response.data.customersplace.Customer
          this.customerPlace.data['kund'] = customer.id
          if (this.schema.objectProps.hasLocation) {
            this.mapArray = [
              {Id: this.customerPlace.id, Name: this.customerPlace.data.name, Latitude: this.customerPlace.data.latitude, Longitude: this.customerPlace.data.longitude, Title: this.customerPlace.data.name, Data: this.customerPlace.data.name, Address: this.customerPlace.data.address, Postal: this.customerPlace.data.postal, City: this.customerPlace.data.city}
            ]
          }
          if (this.customerPlace.data.fileGroups) {
            let fileGroups = this.schema.fields.find(field => field.model === 'fileGroups')
            fileGroups.values = this.customerPlace.data.fileGroups
          }
          this.getCustomers()
        })
        .catch(error => console.log(error))
    },
    onSave () {
      var url = '/api/customersplaces/' + this.customerPlace.id
      var CustomerSelect = document.getElementById('kund')
      var selectedCustomerValue = CustomerSelect.options[CustomerSelect.selectedIndex].value
      this.$http
        .put(url, {
          customerPlace: {
            customerId: selectedCustomerValue,
            data: this._.omit(this.customerPlace.data, 'submit', 'kund')
          }
        })
        .then(response => {
          this.$router.push('/customerPlacesList')
        })
        .catch(error => console.log(error))
    },
    onCopy () {
      let message = 'Vill du kopiera leveransstället?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var copyCustomerPlace = Object.assign({}, this.customerPlace)
          let data = copyCustomerPlace
          delete data.data['inActive']
          delete data.data['onlyTruck']
          delete data.data['washAtCustomer']

          data.data.latitude = ''
          data.data.longitude = ''
          data.data.onlyTruckRegistrant = ''
          data.data.onlyTruckDate = ''
          data.data.name = data.data.name + ' (KOPIA)'
          var url = '/api/customersplaces'
          this.$http
            .post(url, {
              customerPlace: {
                customerId: data.customerId,
                data: this._.omit(data.data, 'submit')
              }
            })
            .then(response => {
              this.$router.push({ name: 'CustomerPlacesDetails', params: { id: response.data.id, customerPlace: data, searchval: '' } })
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/customersplaces/' + this.customerPlace.id
          this.$http
            .delete(url)
            .then(response => {
              this.$router.push('/customerPlacesList')
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.push('/customerPlacesList')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerPlacesDetails.vue